import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import Toast from "../../../helper/Toast";
import CreateFinanceProductFormView from "./CreateFinanceProductFormView";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import FinanceProduct from "../../../../model/financeProduct/FinanceProduct";
import {createFinanceProduct} from "../../../../store/action/financeProduct/financeProduct";

interface IComponentProps {
	/**
	 * Close modal callback
	 */
	closeModal: () => void
}

interface IDispatchProps {
	/**
	 * Crete finance product.
	 */
	createFinanceProduct: (data: FinanceProduct, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps;

class CreateFinanceProductForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<CreateFinanceProductFormView onSubmit={this.onSubmit}
									 onCancel={this.props.closeModal}
									 isSubmitting={this.state.isSubmitting}/>
		);
	}

	onSubmit(data: FinanceProduct) {
		this.setState({isSubmitting: true}, () => {
			this.props.createFinanceProduct(
				data,
				() => {
					Toast.success("Finance product created", "Finance product creation");
					this.setState({isSubmitting: false});
					this.props.closeModal();
				},
				(error) => {
					notifyBugsnagAndShowToast(error, "Finance product creation");
					this.setState({isSubmitting: false});
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createFinanceProduct: (data: FinanceProduct, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(createFinanceProduct(data, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(CreateFinanceProductForm);
